const checkboxOfToggleControls = document.querySelectorAll(".financial-details-checkbox");
const inputOfFinancialDetails = document.querySelectorAll(".financial-details-input");

if(checkboxOfToggleControls.length) {
    checkboxOfToggleControls.forEach(checkbox => {
        if(checkbox) {
            checkbox.addEventListener("change", (e) => {
                const __checkbox_item = e.target.dataset.financial;
                const __is_checked = !e.target.checked;

                inputOfFinancialDetails.forEach(input => {
                    if(input.dataset.financial == __checkbox_item) {
                        input.disabled = __is_checked;
                    }
                })

            })
        }
    })
}